import React, { useState } from 'react';
import { cn } from '../../lib/cn';
import { Sidebar } from '../Sidebar/Sidebar';
import type { SidebarProps } from '../Sidebar/Sidebar';
import { TopBar } from '../TopBar/TopBar';
import type { TopBarProps } from '../TopBar/TopBar';

export interface AppShellProps {
  sidebar: SidebarProps;
  topbar?: TopBarProps;
  header?: React.ReactNode;
  children: React.ReactNode;
  fill?: boolean;
  defaultSidebarCollapsed?: boolean;
  sidebarCollapsed?: boolean;
  onSidebarCollapsedChange?: (collapsed: boolean) => void;
  /** Optional accent strip rendered above the full shell (e.g. Growth module bar). */
  accentBar?: string;
  className?: string;
}

export function AppShell({
  sidebar,
  topbar,
  header,
  children,
  fill,
  defaultSidebarCollapsed = false,
  sidebarCollapsed: sidebarCollapsedProp,
  onSidebarCollapsedChange,
  accentBar,
  className,
}: AppShellProps) {
  const [internalCollapsed, setInternalCollapsed] = useState(defaultSidebarCollapsed);
  const collapsed = sidebarCollapsedProp ?? internalCollapsed;
  const setCollapsed = onSidebarCollapsedChange ?? setInternalCollapsed;

  return (
    <div className={cn('flex min-h-screen flex-col bg-[var(--cream-0)]', className)}>
      <div className="flex min-h-0 flex-1">
        <Sidebar {...sidebar} collapsed={collapsed} onCollapsedChange={setCollapsed} />
        <div className="flex h-screen min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          {topbar && <TopBar {...topbar} />}
          {header}
          <main
            className={cn(
              'relative z-0 flex min-h-0 flex-1 flex-col',
              fill ? 'overflow-hidden p-0' : 'overflow-auto p-6'
            )}
          >
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}
